import React from 'react';
import { Helmet } from 'react-helmet';
import SeoLandingPage from './SeoLandingPage';
import RemainingLandingContent from './RemainingLandingContent';

const WhatsappNotifications = () => (
  <>
    <Helmet>
      <title>WhatsApp Business Notifications API | HAWKTRION</title>
      <meta name="description" content="Send WhatsApp order updates, appointment reminders, and service notifications from business events using HAWKTRION messaging workflows." />
      <meta name="keywords" content="WhatsApp business notifications, WhatsApp notification API, transactional WhatsApp messages" />
      <meta name="robots" content="index,follow" />
      <link rel="canonical" href="https://waba.hawktrion.com/whatsapp-notifications/" />
      <meta property="og:title" content="WhatsApp Business Notifications API | HAWKTRION" />
      <meta property="og:description" content="Send WhatsApp order updates, appointment reminders, and service notifications from business events using HAWKTRION messaging workflows." />
      <meta property="og:type" content="website" />
      <meta property="og:url" content="https://waba.hawktrion.com/whatsapp-notifications/" />
      <meta property="og:image" content="https://waba.hawktrion.com/logo.png" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="WhatsApp Business Notifications API | HAWKTRION" />
      <meta name="twitter:description" content="Send WhatsApp order updates, appointment reminders, and service notifications from business events using HAWKTRION messaging workflows." />
      <meta name="twitter:image" content="https://waba.hawktrion.com/logo.png" />
    </Helmet>
    <SeoLandingPage title="WhatsApp Notifications for Business Updates" hideCta>
      <RemainingLandingContent pageKey="notifications" />
    </SeoLandingPage>
  </>
);

export default WhatsappNotifications;